import styled, { css } from "styled-components";
import * as SS from "../../styled.js";
export const TabsWrapper = styled(SS.TabsWrapper).withConfig({
    displayName: "styled__TabsWrapper",
    componentId: "sc-763e72a8-0"
})`
	${({ $orientation ='horizontal'  })=>{
    if ($orientation === 'horizontal') return css`
				border-top: 1px solid ${({ theme  })=>theme.border.color.base};
			`;
}}
`;

//# sourceMappingURL=styled.js.map